module.exports = __webpack_public_path__ + "fonts/BridgestoneType-Bold.277a3f48.woff";